module.exports = __webpack_public_path__ + "img/vertical_5_1_7042.841c4302.png";